import { ChangeDetectorRef, Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { ChangePasswordRequestData, LoginUserData, SecurityResultStatus, UserRoleData } from 'src/app/clients/system-api/SystemApiClient';
import { SnackBarService } from 'src/app/services/snack-bar.service';
import { Router } from '@angular/router';
import { UserService } from 'src/app/services/user.service';
import { MatDrawer, MatDrawerContainer } from '@angular/material/sidenav';
import { BreakpointObserver } from '@angular/cdk/layout';
import { trigger, transition, style, animate } from '@angular/animations';
import { SessionStorageService } from 'src/app/services/session-storage.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { GenericModalComponent } from 'src/app/components/modals/generic-modal/generic-modal.component';
import { WindowDimensions, WindowDimensionsService } from 'src/app/services/window-dimension-service.service';
import { ScrollLockConfig, ScrollLockService } from 'src/app/services/scroll-lock.service';

@Component({
  selector: 'app-dashboard-page',
  templateUrl: './dashboard-page.component.html',
  styleUrls: ['./dashboard-page.component.scss'],
  animations: [
    trigger('fade', [
      transition('void => *', [
        style({ opacity: 0 }),
        animate(500, style({opacity: 1}))
      ])
    ])
  ]
})
export class DashboardPageComponent implements OnInit {
  @Input() public isUserLoggedIn: boolean | undefined;

  windowDimensions: WindowDimensions = {} as WindowDimensions;

  TransLang: string[] = [];
  userData: LoginUserData | undefined;
  userDataDetails= {} as UserRoleData | undefined;
  userId!: number;
  selectedLanguage: string = 'mk';
  initials : string | undefined;

  showChangePasswordPopup: boolean = false;
  changePasswordPopupState: boolean = false;
  hasChangedPassword: boolean = false;
  
  isFieldRequired = true;
  passwordsForm!: FormGroup
  changePasswordData?: ChangePasswordRequestData;
  oldPassword: string | undefined;
  newPassword : string | undefined;
  confirmPassword: string  | undefined;

  isChangePasswordModalOpen: any;
  scrollLocked: boolean = false;

  @ViewChild(MatDrawer) sidenav!: MatDrawer;
  @ViewChild(MatDrawerContainer) matDrawerContainer!: MatDrawerContainer;
  @ViewChild(GenericModalComponent) genericModalComponent!: GenericModalComponent;
  @ViewChild ('sideNavContent') sideNavContent!: ElementRef;
  @ViewChild ('drawer') drawer!: MatDrawer;

  constructor(private translate: TranslateService,
              public sessionStorageService: SessionStorageService,
              private observer: BreakpointObserver,
              private snackbarService: SnackBarService,
              private userService: UserService,
              private _snackBarService : SnackBarService,
              private cdref: ChangeDetectorRef,
              private _router: Router,
              private formBuilder: FormBuilder,
              private _windowDimensionService: WindowDimensionsService,
              private scrollLockService: ScrollLockService) {
    translate.setDefaultLang('mk');
    translate.addLangs(['mk', 'al','en']);

    this._windowDimensionService.getWindowDimensions$().subscribe((dimensions) => {
      this.windowDimensions = dimensions;

      if(this.windowDimensions.width < this.windowDimensions.threshold_md){
        if(this.sidenav !== undefined && this.sidenav.opened){
          this.sidenav.close();
          this.scrollLockService.enableScroll();
          this.scrollLocked = false;
        }
      } else {
        if(this.sidenav !== undefined && !this.sidenav.opened){
          if(this.sidenav.opened){
            this.sidenav.mode = 'side';
          }
        }
      }
    });
  }

  ngAfterViewInit() {
    setTimeout(() => {
      this.observer.observe(['(max-width: 768px)']).subscribe((res: { matches: any }) => {
        if (res.matches) {
          if (this.matDrawerContainer) {
            this.matDrawerContainer.hasBackdrop = true;
            this.cdref.detectChanges();
          }
          if(this.sidenav !== undefined && this.sidenav.opened){
            if(this.windowDimensions.width < this.windowDimensions.threshold_md){ this.sidenav.mode = 'over'; }
            this.sidenav.close();
          }
        } else {
          if (this.matDrawerContainer) {
            this.matDrawerContainer.hasBackdrop = false;
            this.cdref.detectChanges();
          }
          this.sidenav.mode = 'side'; 
          this.sidenav.open();
        }
      });
    });

    if(this.sidenav !== undefined) {
      this.sidenav.openedChange.subscribe((opened) => {
        if (opened) {
          if(this.windowDimensions.width < this.windowDimensions.threshold_md){
            this.sidenav.mode = 'over'; 
            
            this.scrollLockService.disableScroll({ 
              allow_touch_input_on: this.sideNavContent !== undefined ? [this.sideNavContent.nativeElement] : undefined,
              handle_extreme_overflow: false,
              animation_duration: 0,
              handle_touch_input: true,
              mobile_only_touch_prevention: false
            } as ScrollLockConfig);
            this.scrollLocked = true;
          }
        } else {
          this.sidenav.mode = 'side'; 
          if(this.scrollLocked) {
            this.scrollLockService.enableScroll();
            this.scrollLocked = false;
          }
        }
      });
    }
  }

  ngOnInit(): void {
    this.initializeForm();
    this.getTransLanguage();

    this.userData = this.sessionStorageService.getProfile();
    if(this.userData != null){
      this.isUserLoggedIn = true;  
    } else{
      this.isUserLoggedIn = false;
    }

    this.initials = this.extractInitials(this.userData.name!, this.userData.surname!);
  }

  closeSidenav() {
    this.sidenav.close();
  }

  toggleSidenav() {
    this.sidenav.toggle();
    if(this.sidenav.opened && this.windowDimensions.width < this.windowDimensions.threshold_md){
      this.sidenav.mode = 'over';
    } else {
      this.sidenav.mode = 'side';
    }
  }

  initializeForm() {
    this.passwordsForm = this.formBuilder.group({
      oldPassword: ['', Validators.required],
      newPassword: ['', Validators.required],
      confirmPassword: ['', Validators.required]
    });
  }

  public async retriveUserDetail(): Promise<void>{
    await new Promise<void>((resolve)=>{
      this.userService.retriveUserDetail(this.userId).subscribe((data)=>{
        this.userDataDetails = data;
        resolve();
      })
    })
  }

  extractInitials(firstName: string, lastName: string): string {
    const firstInitial = firstName.charAt(0);
    const lastInitial = lastName.charAt(0);
  
    return `${firstInitial}${lastInitial}`;
  }

  changeLanguage(language: string) {
    this.translate.use(language);
    this.selectedLanguage = language;
  }
 
  getTransLanguage() {
    this.TransLang = [...this.translate.getLangs()];
  }

  getUser(event: any) {
     this.userService.retriveUserDetail(this.userId).subscribe(() =>{
     this.userId = event;
    });  
  }

  logout() {
    this.userService.signout().subscribe(next => {
      if (next == SecurityResultStatus.Success) {
        this.sessionStorageService.setProfile == null;
        this.snackbarService.callSnackBar(next, "Logout");
        this._router.navigateByUrl("/login");
      } else {
        this.snackbarService.callSnackBar("Error", "error");
      }
      this.snackbarService.callSnackBar(next, "Logout");
    });
  }

  clearFields(){
    this.oldPassword = '';
    this.newPassword = '';
    this.confirmPassword = '';
  }

  openChangePasswordModal() {
    this.showChangePasswordPopup = this.showChangePasswordPopup ? false : true;
  }

  closeChangePasswordModal(){
    this.showChangePasswordPopup = false;
    this.clearFields();
  }

  public async changePassword(changePasswordRequestData: ChangePasswordRequestData): Promise<void> {
    try {
      this.userService.changePassword(changePasswordRequestData).subscribe((data) => {
        if (data === SecurityResultStatus.Success) {
          this._snackBarService.callSnackBar(data, 'Change Password'); 
        } else {
          throw new Error();
        }
      });  
    } catch (error) {
      this._snackBarService.callSnackBar('Error');
    }
  }
   
  public savePassword(oldPassword:string, newPassword:string, confirmPassword:string): void {
    if (newPassword !== confirmPassword && newPassword == '' && confirmPassword == '') {
      this.isFieldRequired = true;
      this._snackBarService.callSnackBar('Change Password');
    } else{
      let changePasswordRequestData = new ChangePasswordRequestData(); 
      changePasswordRequestData.oldPassword = oldPassword; 
      changePasswordRequestData.newPassword = newPassword;
         this.genericModalComponent.handleClose(); 
           this.changePassword(changePasswordRequestData).catch(error => {
        });
    }
  }
}



